import script from "./PlanogramViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanogramViewer.vue?vue&type=script&setup=true&lang=js"

import "./PlanogramViewer.vue?vue&type=style&index=0&id=21863b7c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21863b7c"]])

export default __exports__